


































































































































































































































import { Component, Vue } from "vue-property-decorator";
import onboarding_dialog from "@/components/dialogs/onboarding_dialog.vue";
import confirm_delete_dialog from "@/components/dialogs/confirm_delete_dialog.vue";
import { chat_history_item } from "@/shared/classes/chat_history_item";
import { RouterNames } from "@/router/routernames";
import { EventBus } from "@/shared/services/event-bus-simple";
import { CachedUser, UserCache } from "@/store/modules/user-cached-work";
import { chat_history_service } from "@/store/modules/chat-history";
import { ia_agents_store } from "@/shared/classes/ia_agents_store";

@Component({ components: { onboarding_dialog, confirm_delete_dialog } })
export default class chat_sidebar extends Vue {
  public sidebarOpen: boolean = true;
  public chatHistory: chat_history_item[] = [];
  public isCollapsed: boolean = false;

  public showConfirmDelete: boolean = false;
  public chatPendingDelete: chat_history_item | null = null;

  public showOnboarding: boolean = false;
  public isEditingProfile: boolean = false;
  public userName: string = "";
  public experienceLevel: string = "Bajo";
  public experienceOptions: string[] = ["Bajo", "Medio", "Alto"];

  public mounted(): void {
    this.loadUserFromCache();
    this.loadChatHistory();
    this.loadCollapsedState();
    if (this.userName.length === 0) {
      this.showOnboarding = true;
      this.isEditingProfile = false;
    }
    EventBus.$on("newchatStarted", () => this.loadChatHistory());
  }

  public beforeDestroy(): void {
    EventBus.$off("newchatStarted", () => this.loadChatHistory());
  }

  public get drawerWidth(): number {
    return this.isCollapsed ? 72 : 280;
  }

  public get currentChatId(): string | null {
    if (this.$route && this.$route.name === RouterNames.chatid) {
      if (this.$route.params && this.$route.params.id) {
        return this.$route.params.id as string;
      }
    }
    return null;
  }

  private get agentsById(): Record<string, { name: string; icon?: string }> {
    const list = ia_agents_store.list();
    const map: Record<string, { name: string; icon?: string }> = {};
    for (let i = 0; i < list.length; i++) {
      const a = list[i];
      map[a.id] = { name: a.name, icon: a.icon };
    }
    return map;
  }

  public resolveChatTitle(chat: any): string {
    if (chat && chat.title && String(chat.title).length > 0) return chat.title;
    if (chat && chat.messages && chat.messages.length > 0) {
      const first = chat.messages[0];
      if (first && first.content) return String(first.content).slice(0, 40);
    }
    return "Sin título";
  }

  public get groupedChats() {
    type Group = {
      agentKey: string;
      agentName: string;
      icon?: string;
      lastTs: number;
      chats: chat_history_item[];
    };

    const groupsMap: { [key: string]: Group } = {};
    const agents = this.agentsById;

    for (let i = 0; i < this.chatHistory.length; i++) {
      const c: any = this.chatHistory[i];
      const idAgent =
        c.id_agent != null
          ? c.id_agent
          : c.agentId != null
          ? c.agentId
          : "null";

      const meta =
        idAgent !== "null" && agents[idAgent]
          ? agents[idAgent]
          : { name: "Sin agente", icon: undefined };

      if (!groupsMap[idAgent]) {
        groupsMap[idAgent] = {
          agentKey: idAgent,
          agentName: meta.name,
          icon: meta.icon,
          lastTs: 0,
          chats: [],
        };
      }

      const g = groupsMap[idAgent];
      g.chats.push(c);

      const ts = c.timestamp ? c.timestamp : 0;
      g.lastTs = ts > g.lastTs ? ts : g.lastTs;
    }

    const groups: Group[] = [];
    for (const k in groupsMap) {
      const g = groupsMap[k];
      g.chats.sort(function(a: any, b: any) {
        const ta = a.timestamp ? a.timestamp : 0;
        const tb = b.timestamp ? b.timestamp : 0;
        return tb - ta;
      });
      groups.push(g);
    }

    groups.sort(function(a: Group, b: Group) {
      if (b.lastTs !== a.lastTs) return b.lastTs - a.lastTs;
      return a.agentName.localeCompare(b.agentName, "es");
    });

    return groups;
  }

  public toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.saveCollapsedState();
  }

  private loadCollapsedState(): void {
    try {
      const saved = localStorage.getItem("sidebar_collapsed");
      if (saved !== null) {
        this.isCollapsed = saved === "true";
      }
    } catch (e) {}
  }

  private saveCollapsedState(): void {
    try {
      localStorage.setItem("sidebar_collapsed", String(this.isCollapsed));
    } catch (e) {}
  }

  public createNewChat(): void {
    this.$router
      .push({ name: RouterNames.chatid, params: { id: "" } })
      .catch(function() {});
  }

  public loadChat(chatId: string): void {
    this.$router
      .push({ name: RouterNames.chatid, params: { id: chatId } })
      .catch(function() {});
  }

  public openConfirmDelete(chat: chat_history_item): void {
    this.chatPendingDelete = chat;
    this.showConfirmDelete = true;
  }
  public cancelConfirmDelete(): void {
    this.chatPendingDelete = null;
    this.showConfirmDelete = false;
  }
  public confirmDelete(): void {
    if (!this.chatPendingDelete) {
      this.showConfirmDelete = false;
      return;
    }
    const id = this.chatPendingDelete.id;
    this.chatPendingDelete = null;
    this.showConfirmDelete = false;
    this.deleteChatById(id);
  }

  public deleteChatById(chatId: string): void {
    const index = this.chatHistory.findIndex(function(c) {
      return (c as any).id === chatId;
    });
    if (index > -1) {
      this.chatHistory.splice(index, 1);
      this.saveChatHistory();

      if (this.currentChatId === chatId) {
        if (this.chatHistory.length > 0) {
          this.loadChat((this.chatHistory[0] as any).id);
        } else {
          this.createNewChat();
        }
      }
    }
  }

  public openWorkFlows(): void {
    this.$router.push({ name: RouterNames.workflows });
  }
  public openMarketplace(): void {
    this.$router.push({ name: RouterNames.marketplace });
  }
  public openProfileEditor(): void {
    this.isEditingProfile = true;
    this.showOnboarding = true;
  }

  private loadUserFromCache(): void {
    try {
      var user = UserCache.load();
      if (user != null) {
        this.userName = user.name;
        this.experienceLevel = user.experienceLevel;
      }
    } catch (e) {}
  }
  private loadChatHistory(): void {
    try {
      this.chatHistory = chat_history_service.readAll();
    } catch (e) {}
  }
  private saveChatHistory(): void {
    try {
      chat_history_service.writeAll(this.chatHistory);
    } catch (e) {}
  }

  public formatTs(ts?: number): string {
    if (!ts) return "";
    const d = new Date(ts);
    return (
      d.toLocaleDateString("es-ES") +
      " " +
      d.toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
      } as any)
    );
  }

  public onOnboardingSave(data: { name: string; level: string }): void {
    this.userName = data && data.name ? data.name : "Andrés";
    this.experienceLevel = data && data.level ? data.level : "Bajo";
    this.saveUserToCache();
    this.showOnboarding = false;
  }

  public cancelOnboarding(): void {
    if (this.isEditingProfile) {
      this.showOnboarding = false;
      this.isEditingProfile = false;
      return;
    }
    if (this.userName.length === 0) this.userName = "Andrés";
    if (this.experienceLevel.length === 0) this.experienceLevel = "Bajo";
    this.saveUserToCache();
    this.showOnboarding = false;
  }

  private saveUserToCache(): void {
    try {
      const user: CachedUser = {
        name: this.userName,
        experienceLevel: this.experienceLevel,
        lastUpdate: new Date().getTime(),
      };
      UserCache.save(user);
    } catch (e) {}
  }
}
